<div class="info-card">
  <div class="info-card-header">
    <lucide-icon *ngIf="icon" [name]="icon" class="-lucide-icon"></lucide-icon>
    <h3>{{ title }}</h3>
  </div>
  <div class="info-card-body">
    <ng-content></ng-content>
  </div>
</div>
